import { Factory } from 'miragejs';
import faker from 'faker';

export default {
  document: Factory.extend({
    title: (i) => `${i} ${faker.lorem.sentence()}`,
  }),
};
